import { Box, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import HomeworkReviewCommentCell from "./HomeworkReviewCommentCell";
import { HomeworkInfo } from "../../../../redux/homework/homeworkSlice";
import { LoadState } from "../../../../redux/common";
import PrizaGridBar from "../../../../features/base/grid/PrizaGridBar";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import StudentTile from "../../../../features/core/StudentTile";
import { homeworkReportSlice, retrieveHomeworkReport, selectHomeworkReport } from "../../../../redux/homework/homeworkReportSlice";
import { HomeworkDone } from "../../../../redux/homework/homeworkCheckSlice";
import HomeworkReviewCheckCell from "./HomeworkReviewCheckCell";

interface HomeworkReviewProps {
    homework: HomeworkInfo;
    onBack: () => void;
}

const HomeworkReview = ({ homework, onBack }: HomeworkReviewProps) => {
    const dispatch = useAppDispatch();
    const homeworkReport = useSelector(selectHomeworkReport);
    useEffect(() => {
        dispatch(homeworkReportSlice.actions.check({ 
            homeworkId: homework.id, 
            classroomId: homework.classroomId 
        }));
        if(homeworkReport.state.state === LoadState.NotStarted) {
            dispatch(retrieveHomeworkReport({ 
                homeworkId: homework.id, 
                classroomId: homework.classroomId 
            }));
        }
    }, [homework.id, homework.classroomId, homeworkReport]);

    
    const toolbar = {
        label: <>
        <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6">
                Tarefa:
            </Typography>
            <Typography variant="h6">
                {homework.name}
            </Typography>
        </Stack>
        </>,
        buttons: [
            {
                label: "Voltar",
                click: onBack,
            }
        ]
    };

    const buildContent = () => {
        const students = homeworkReport.response?.students || [];
        if (students.length == 0) {
            return <Typography variant="body1">Nenhum estudante encontrado para esta turma.</Typography>;
        }
        // Transform checks array into a hashmap by studentId
        const checksArr = homeworkReport.response?.checks || [];
        const checks: Record<string, typeof checksArr[number]> = {};
        for (const check of checksArr) {
            if (check.studentId) checks[check.studentId] = check;
        }
        // Transform comments array into a hashmap by studentId
        const commentsArr = homeworkReport.response?.comments || [];
        const comments: Record<string, typeof commentsArr[number]> = {};
        for (const comment of commentsArr) {
            if (comment.studentId) comments[comment.studentId] = comment;
        }
        const sx = {
            padding: "4px 8px",
        };
        return <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Aluno</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Status</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                        }}>Comentário</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {students.map((item) => {
                    const check = checks[item.id];
                    const comment = comments[item.id];
                    return <TableRow key={item.id} hover>
                        <TableCell sx={sx}>
                            <StudentTile id={item.id} />
                        </TableCell>
                        <TableCell sx={sx}>
                            <HomeworkReviewCheckCell homework={homework} studentId={item.id} check={check} />
                        </TableCell>
                        <TableCell sx={sx}>
                            <HomeworkReviewCommentCell homework={homework} studentId={item.id} comment={comment} />
                        </TableCell>
                    </TableRow>;
                })}
                </TableBody>
            </Table>
        </>;
    };

    let content: React.ReactNode = "";
    if(
        // homeworkClassroomList.state.state === LoadState.Loaded
        homework
    ) {
        content = (
            <Box sx={{ m: 2, width: "100%" }}>
                {
                    buildContent()
                }
            </Box>
        );
    } else {
        content = <Typography variant="body1" sx={{ m: 2 }}>Carregando...</Typography>;
    }

    const retry = () => {
        dispatch(homeworkReportSlice.actions.clean());
    };

    return <Paper sx={{ width: "100%", minWidth: "300px" }} elevation={3}>
        <PrizaGridBar toolbar={toolbar} retry={retry} />
        <Box display={"flex"} width="100%">
            {content}
        </Box>
    </Paper>;
};

export default HomeworkReview;
